import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientEditAmlEstimatedWorthFormErrorStatesEnum {
    UpdateAnnualNetIncomeFailed = ErrorStateScheduleEnum.PanelClientEditAmlEstimatedWorthFormErrorStatesStartIndex,
    UpdateEstimatedNetWorthFailed,
    UpdateIntendedInvestAmountFailed,
    GetIndividualFailed,
}
